<button type="button" (click)="onClick()"><span><i class="pi pi-file-pdf"></i> Vytisknout do PDF</span></button>
<p-blockUI [blocked]="blocked">
  <p-progress-spinner ariaLabel="Načítání" />
</p-blockUI>
<p-dialog header="Výsledek" [(visible)]="dialogVisible" (onHide)="onClose()" [modal]="true">
  <p>
    Pokud si přejete vyplněný formulář dále upravit a znovu uložit a vytisknout, zvolte "Opravit". V opačném případě zvolte "Ukončit" (dojde k vyprázenění formuláře).
  </p>

  <ng-template #footer>
    <button type="button" (click)="onClose()"><span><i class="pi pi-undo"></i> Opravit</span></button>
    <button type="button" (click)="onClear()"><span><i class="pi pi-check"></i> Ukončit</span></button>
  </ng-template>
</p-dialog>

